module.exports = __webpack_public_path__ + "static/rs-logo-2c79514eee110ae73f03333afd65c849.svg";